export default {
      id: "chevron-usage",
      viewBox: "0 0 5.7 8.5",
      url: __webpack_public_path__ + "svg/sprite.svg#chevron",
      toString: function () {
        return this.url;
      }
    }